import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import RetailerList from './retailer-list';
import clsx from 'clsx';
import NewRetailerList from './new-retailer-list';

const RetailerManagement = () => {
    const { t } = useTranslation();
    const [tab, setTab] = useState('RetailerList')

    return (
        /*<TabPanel id="tabs" 
        selectedIndex={selectedIndex}
        onSelectionChanged={(e:any) => setSelectedIndex(e.component.option("selectedIndex"))}
        >
            <Item title={t("retailer_list")}>
                <RetailerList></RetailerList>
            </Item>
        </TabPanel>*/
        <div className='card card-custom'><div className='card-header card-header-stretch overflow-auto'>
            <ul
                className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                role='tablist'
            >
                <li className='nav-item'>
                    <a
                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'RetailerList' })}
                        onClick={() => setTab('RetailerList')}
                        role='tab'
                    >
                        {t("retailer_list")}
                    </a>
                </li>
                <li className='nav-item'>
                    <a
                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'NewRetailerList' })}
                        onClick={() => setTab('NewRetailerList')}
                        role='tab'
                    >
                        {t("new_retailer_list")}
                    </a>
                </li>
            </ul>
        </div>
            <div className='tab-content pt-3'>
                <div className={clsx('tab-pane', { active: tab === 'RetailerList' })}>

                    <RetailerList></RetailerList>

                </div>
                <div className={clsx('tab-pane', { active: tab === 'NewRetailerList' })}>

                    <NewRetailerList></NewRetailerList>

                </div>
            </div>
        </div>
    )
}
export default RetailerManagement